// extracted by mini-css-extract-plugin
module.exports = {"body":"Account_body__25_03","subHeader":"Account_subHeader__3qS2b","noMarginY":"Account_noMarginY__2_mKX","noPaddingBottom":"Account_noPaddingBottom__3tfdQ"};